import { styled, Typography } from "@mui/material"

export const CustomizedTypographyRaleway = styled(Typography)`
font-family: 'Raleway', sans-serif;
`;

export const CustomizedTypographyLexendExtraLight = styled(Typography)`
font-family: 'Lexend', sans-serif;
`;